<!--
 * @Description: 需求管理 修改
 * @Author: PF
 * @Date: 2023-12-19 11:07:48
 * @LastEditors: PF
 * @LastEditTime: 2026-10-09 17:04:46
-->
<template>
  <div>
    <el-dialog class="wp93 hp93" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="106px">
        <el-row gutter="10">
          <el-col :span="8">
            <el-form-item label="标题" prop="bt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.bt" />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="所属菜单">
              <span v-if="ruleForm.sscdlj">{{ruleForm.sscdlj + '-' + ruleForm.menuMc}}</span>
              <span v-else-if="ruleForm.xtmc && !ruleForm.menuMc">{{ ruleForm.xtmc }}-首页</span>
              <span v-else-if="!ruleForm.xtmc && !ruleForm.menuMc">首页</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" prop="lx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.lx" clearable filterable>
                <el-option v-for="(item, index) in xqlxData.list" :key="index" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提出人" prop="tcr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.tcr" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提出时间" prop="tcsj">
              <el-date-picker v-model="ruleForm.tcsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="解决人" prop="jjr">
              <el-input v-model="ruleForm.jjr" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="要求解决时间" prop="yqjjsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.yqjjsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="解决状态" prop="jjzt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-radio-group v-model="ruleForm.jjzt" clearable filterable style="height: auto;">
                <el-radio v-for="item in jjztData.list" :key="item.value" :value="item.value">{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="ruleForm.jjzt === jjztData.yjj">
            <el-form-item label="实际解决时间" prop="jjsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.jjsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述 " prop="ms">
              <ueditor v-model:value="ruleForm.ms" :row="{height:500}" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { actionPatch, loadData, closeWindow, loadSelect } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import ueditor from '@/components/ueditor.vue'

const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

// 需求类型
const xqlxData = ref({ list: [] })
loadSelect({ url: '/api/v2/sys/xuqiu/xuqiuleixing', data: xqlxData })
// 解决状态
const jjztData = ref({ list: [] })
loadSelect({ url: '/api/v2/sys/xuqiu/jiejuezhuangtai', data: jjztData })

watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadData({
        url: '/api/v2/sys/xuqiu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value.lx = res.data.lx ? res.data.lx.value : res.data.lx
          ruleForm.value.jjzt = res.data.jjzt ? res.data.jjzt.value : res.data.jjzt
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  const forms = unref(ruleFormRef)
  if (!forms) return
  await forms.validate()
  actionPatch({ url: '/api/v2/sys/xuqiu', data: ruleForm.value }).then(res => {
    if (res.code === 200) {
      successPrompt(res.message)
      closeWindow('openEdit', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
